import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionEditComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { useMemo } from 'react';
import styled from '@xstyled/styled-components';
import { getSize, getColor } from '@lib/common';
import { AnswerItem, SubQuestionItem } from './components';
import { Button, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledContentWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding24'));
var StyledSection = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
var StyledSectionTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #1e293b;\n"])), getSize('typo16'));
var StyledItemsList = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding12'));
var StyledAddButton = styled(Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 48px;\n  border: 2px dashed #cbd5e1 !important;\n  border-radius: ", " !important;\n  background-color: transparent !important;\n  color: #475569 !important;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n\n  &:hover {\n    border-color: ", " !important;\n    color: ", " !important;\n    background-color: #f8fafc !important;\n  }\n\n  .anticon {\n    font-size: ", ";\n  }\n"])), getSize('radiusS'), getSize('padding8'), getColor('fillIntActive'), getColor('fillIntActive'), getSize('typo16'));
var StyledIndexPrefix = styled.strong(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: #2563eb;\n  flex-shrink: 0;\n"])), getSize('typo14'));
export var MatchingEditComponent = function MatchingEditComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;
  var matchingLabel = states.matchingLabel,
      label = states.label;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var matchingQuestion = question;
  var readonly = states.readonly; // Validate: all answers have description, all sub-questions have description + linked answer

  var isMatchingValid = useMemo(function () {
    var answers = matchingQuestion.answers || [];
    var subQuestions = matchingQuestion.subQuestions || [];
    var correctAnswers = matchingQuestion.correctAnswers || [];
    if (answers.length === 0 || subQuestions.length === 0) return false;
    var allAnswersFilled = answers.every(function (a) {
      return a.description && a.description.trim().length > 0;
    });
    var allSubQuestionsFilled = subQuestions.every(function (sq) {
      var hasDescription = sq.description && sq.description.trim().length > 0;
      var hasLinkedAnswer = correctAnswers.some(function (ca) {
        return ca.subQuestionId === sq.id.toString() && ca.answerId && ca.answerId.trim().length > 0 && answers.some(function (a) {
          return a.id.toString() === ca.answerId;
        });
      });
      return hasDescription && hasLinkedAnswer;
    });
    return allAnswersFilled && allSubQuestionsFilled;
  }, [matchingQuestion.answers, matchingQuestion.subQuestions, matchingQuestion.correctAnswers]);
  var overriddenStates = useMemo(function () {
    return _objectSpread(_objectSpread({}, states), {}, {
      isValidForSave: isMatchingValid
    });
  }, [states, isMatchingValid]); // Get answer options for answer section

  var answerOptions = useMemo(function () {
    if (!matchingQuestion.answers || matchingQuestion.answers.length === 0) {
      return [];
    }

    return matchingQuestion.answers.map(function (answer, index) {
      return {
        value: answer.id.toString(),
        label: /*#__PURE__*/_jsxs(Space, {
          size: 4,
          children: [/*#__PURE__*/_jsxs(StyledIndexPrefix, {
            children: [String.fromCharCode(65 + index), "."]
          }), ' ', /*#__PURE__*/_jsx("span", {
            children: answer.description || ''
          })]
        })
      };
    });
  }, [matchingQuestion.answers]);
  return /*#__PURE__*/_jsx(BaseQuestionEditComponent, {
    states: overriddenStates,
    actions: actions,
    children: /*#__PURE__*/_jsxs(StyledContentWrapper, {
      children: [/*#__PURE__*/_jsxs(StyledSection, {
        children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
          children: "Answer Options"
        }), /*#__PURE__*/_jsx(StyledItemsList, {
          children: matchingQuestion.answers && matchingQuestion.answers.length > 0 && matchingQuestion.answers.map(function (answer, index) {
            return /*#__PURE__*/_jsx(AnswerItem, {
              type: "option",
              index: index,
              answer: answer,
              onUpdate: function onUpdate(value) {
                var _actions$onUpdateAnsw;

                (_actions$onUpdateAnsw = actions.onUpdateAnswer) === null || _actions$onUpdateAnsw === void 0 ? void 0 : _actions$onUpdateAnsw.call(actions, answer.id.toString(), value);
              },
              onDelete: matchingQuestion.answers.length > 1 ? function () {
                var _actions$onDeleteAnsw;

                (_actions$onDeleteAnsw = actions.onDeleteAnswer) === null || _actions$onDeleteAnsw === void 0 ? void 0 : _actions$onDeleteAnsw.call(actions, [answer.id.toString()]);
              } : undefined,
              readonly: readonly,
              matchingLabel: matchingLabel
            }, answer.id.toString());
          })
        }), !readonly && /*#__PURE__*/_jsx(StyledAddButton, {
          type: "dashed",
          icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
          onClick: function onClick() {
            var _actions$onAddAnswer;

            (_actions$onAddAnswer = actions.onAddAnswer) === null || _actions$onAddAnswer === void 0 ? void 0 : _actions$onAddAnswer.call(actions);
          },
          children: "Add Answer Option"
        })]
      }), /*#__PURE__*/_jsxs(StyledSection, {
        children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
          children: "Questions"
        }), /*#__PURE__*/_jsx(StyledItemsList, {
          children: matchingQuestion.subQuestions && matchingQuestion.subQuestions.length > 0 && matchingQuestion.subQuestions.map(function (subQuestion, index) {
            var _question$index;

            // Find the correct answer for this sub question
            var correctAnswer = matchingQuestion.correctAnswers.find(function (ca) {
              return ca.subQuestionId === subQuestion.id.toString();
            });
            var matchedAnswer = correctAnswer ? matchingQuestion.answers.find(function (a) {
              return a.id.toString() === correctAnswer.answerId;
            }) : undefined; // Calculate display index based on question index
            // Example: question.index=4, index=0 -> displayIndex=4
            //          question.index=4, index=1 -> displayIndex=5

            var displayIndex = ((_question$index = question.index) !== null && _question$index !== void 0 ? _question$index : 1) + index;
            return /*#__PURE__*/_jsx(SubQuestionItem, {
              index: displayIndex,
              subQuestion: subQuestion,
              matchedAnswer: matchedAnswer,
              answerOptions: answerOptions,
              score: (correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.score) || 1,
              onUpdateSubQuestion: function onUpdateSubQuestion(value) {
                var _actions$onUpdateSubQ;

                (_actions$onUpdateSubQ = actions.onUpdateSubQuestion) === null || _actions$onUpdateSubQ === void 0 ? void 0 : _actions$onUpdateSubQ.call(actions, subQuestion.id.toString(), value);
              },
              onUpdateAnswer: function onUpdateAnswer(answerId) {
                var _actions$onUpdateCorr;

                (_actions$onUpdateCorr = actions.onUpdateCorrectAnswer) === null || _actions$onUpdateCorr === void 0 ? void 0 : _actions$onUpdateCorr.call(actions, subQuestion.id.toString(), answerId);
              },
              onUpdateScore: function onUpdateScore(score) {
                var _actions$onUpdateCorr2;

                (_actions$onUpdateCorr2 = actions.onUpdateCorrectAnswerScore) === null || _actions$onUpdateCorr2 === void 0 ? void 0 : _actions$onUpdateCorr2.call(actions, subQuestion.id.toString(), score);
              },
              onDelete: matchingQuestion.subQuestions.length > 1 ? function () {
                var _actions$onDeleteSubQ;

                (_actions$onDeleteSubQ = actions.onDeleteSubQuestion) === null || _actions$onDeleteSubQ === void 0 ? void 0 : _actions$onDeleteSubQ.call(actions, subQuestion.id.toString());
              } : undefined,
              readonly: readonly,
              baseLabel: label,
              matchingLabel: matchingLabel
            }, subQuestion.id.toString());
          })
        }), !readonly && /*#__PURE__*/_jsx(StyledAddButton, {
          type: "dashed",
          icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
          onClick: function onClick() {
            var _actions$onAddSubQues;

            (_actions$onAddSubQues = actions.onAddSubQuestion) === null || _actions$onAddSubQues === void 0 ? void 0 : _actions$onAddSubQues.call(actions);
          },
          children: "Add Sub Question"
        })]
      })]
    })
  });
};